const errorMessage = {
    SESSION_EXPIRED:
        'Ihre Sitzung ist abgelaufen, bitte loggen Sie sich erneut ein'
}

export { errorMessage }
